import { supabase } from '../lib/supabase';

class ScanHistoryService {
  // Get all scan history for a user
  async getScanHistory(userId) {
    try {
      const { data, error } = await supabase
        .from('scan_history')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(50);

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error fetching scan history:', error);
      return { data: null, error };
    }
  }

  // Save a new scan to the database
  async saveScan(scanData, userId) {
    try {
      const scanPayload = {
        user_id: userId,
        vin: scanData.vin,
        make: scanData.make || 'Unknown',
        model: scanData.model || 'Unknown',
        year: scanData.year || null,
        engine: scanData.engine || null,
        transmission: scanData.transmission || null,
        fuel_type: scanData.fuelType || null,
        body_type: scanData.bodyType || null,
        color: scanData.color || null,
        doors: scanData.doors || null,
        displacement: scanData.displacement || null,
        power: scanData.power || null,
        cylinders: scanData.cylinders || null,
        drive_type: scanData.driveType || null,
        trim: scanData.trim || null,
        series: scanData.series || null,
        country: scanData.country || null,
        plant: scanData.plant || null,
        captured_image: scanData.capturedImage || null,
        source: scanData.source || 'VIN Scanner',
        has_order: scanData.hasOrder || false,
        is_unknown: scanData.isUnknown || false,
        error_message: scanData.error || null,
        metadata: {
          original_data: scanData,
          scanned_at: new Date().toISOString()
        }
      };

      const { data, error } = await supabase
        .from('scan_history')
        .insert([scanPayload])
        .select()
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error saving scan:', error);
      return { data: null, error };
    }
  }

  // Update scan history when an order is created
  async updateScanOrderStatus(vin, userId, hasOrder = true) {
    try {
      const { data, error } = await supabase
        .from('scan_history')
        .update({ has_order: hasOrder })
        .eq('vin', vin)
        .eq('user_id', userId);

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error updating scan order status:', error);
      return { data: null, error };
    }
  }

  // Delete all scan history for a user
  async clearScanHistory(userId) {
    try {
      const { error } = await supabase
        .from('scan_history')
        .delete()
        .eq('user_id', userId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error clearing scan history:', error);
      return { error };
    }
  }

  // Delete a specific scan
  async deleteScan(scanId, userId) {
    try {
      const { error } = await supabase
        .from('scan_history')
        .delete()
        .eq('id', scanId)
        .eq('user_id', userId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error deleting scan:', error);
      return { error };
    }
  }

  // Get scan by VIN
  async getScanByVIN(vin, userId) {
    try {
      const { data, error } = await supabase
        .from('scan_history')
        .select('*')
        .eq('vin', vin)
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(1)
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error fetching scan by VIN:', error);
      return { data: null, error };
    }
  }
}

export default new ScanHistoryService();
